'use client';

/**
 * Account & workspace domain helpers (design: Propensify_Workspaces_and_Account).
 *
 * Single home for workspace-kind handling, role labels, and list sorting so
 * every surface (menu, settings, gates) agrees.
 */

export type WorkspaceKind = 'personal' | 'team';

export interface WorkspaceItem {
  clerk_id: string;
  name: string;
  kind: WorkspaceKind;
}

export function normalizeKind(value: unknown): WorkspaceKind {
  return value === 'personal' ? 'personal' : 'team';
}

export function kindLabel(kind: WorkspaceKind): 'Personal' | 'Team' {
  return kind === 'personal' ? 'Personal' : 'Team';
}

/**
 * Role label per the design permissions table. Personal owners are "Owner";
 * team admins "Admin"; everyone else "Member".
 */
export function roleLabel(kind: WorkspaceKind, clerkRole: string | null): string {
  if (kind === 'personal') return 'Owner';
  return clerkRole === 'org:admin' || clerkRole === 'admin' ? 'Admin' : 'Member';
}

export function isAdminRole(clerkRole: string | null): boolean {
  return clerkRole === 'org:admin' || clerkRole === 'admin';
}

/** Personal workspaces first, then teams A–Z (design §02). */
export function sortWorkspaces<T extends { kind: WorkspaceKind; name: string }>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    if (a.kind !== b.kind) return a.kind === 'personal' ? -1 : 1;
    return a.name.localeCompare(b.name);
  });
}


